import HttpRequest from "@/api/axios";
import moment    from 'moment'
const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);

export default {
    userState(data) {
        return axios.request({
            url: "mwap2/userstate",
            method: "post",
            data
        });
    },
    getList(data) {
        return axios.request({
            url: "mwap2/list?page="+data.page,
            method: "post",
            data
        });
    },
    getUser(data) {
        return axios.request({
            url: "mwap2/usercount",
            method: "post",
            data
        });
    },
    getVoteRank(data) {
        return axios.request({
            url: "mwap2/rank?page="+data.page,
            method: "post",
            data
        });
    },
    getDistanceRank(data) {
        return axios.request({
            url: "mwap2/distancerank?page="+data.page,
            method: "post",
            data
        });
    },
    getMyVote(data) {
        return axios.request({
            url: "mwap2/userrank",
            method: "post",
            data
        });
    },
    getRest(data) {
        return axios.request({
            url: "mwap2/countscore",
            method: "post",
            data
        });
    }
}
